export const Constants = {
    fontFamilyJosefinSans: "Josefin Sans",
};